"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _netlifyIdentityWidget = _interopRequireDefault(require("netlify-identity-widget"));

/* global __PATH_PREFIX__ */
exports.onInitialClientRender = function (_, _ref) {
  var _ref$enableIdentityWi = _ref.enableIdentityWidget,
      enableIdentityWidget = _ref$enableIdentityWi === void 0 ? true : _ref$enableIdentityWi,
      _ref$publicPath = _ref.publicPath,
      publicPath = _ref$publicPath === void 0 ? "admin" : _ref$publicPath;

  if (enableIdentityWidget) {
    _netlifyIdentityWidget.default.on("init", function (user) {
      if (!user) {
        _netlifyIdentityWidget.default.on("login", function () {
          document.location.href = __PATH_PREFIX__ + "/" + publicPath + "/";
        });
      }
    });

    _netlifyIdentityWidget.default.init();
  }
};